import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { message } from "antd";
import FormInputs from "../../Components/FormInputs/FormInputs";
import Buttons from "../../Components/Buttons/Buttons";
import { postApi } from "../../Utlis/apiService";
import { SET_STUDENT_PASSWORD } from "../../Utlis/apiPath";
import LOGO from "../../Assets/Images/CompanyLogo.jpg";
import "./StudentSetPassword.scss";
import { errorToast, successToast } from "../../Services/ToastHelper";

const StudentSetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [passwordData, setPasswordData] = useState({
    password: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({});
  const [token, setToken] = useState("");
    const [successModal, setSuccessModal] = useState(false);
    const [successResponse, setSuccessResponse] = useState({});
  useEffect(() => {
    // Get token from URL query parameters
    const tokenFromUrl = searchParams.get("token");
    if (tokenFromUrl) {
      setToken(tokenFromUrl);
    } else {
      errorToast("Invalid or missing token");
      // Optionally redirect to login or home page
      // navigate("/login");
    }
  }, [searchParams]);

  const validatePassword = () => {
    let objErrors = {};

    if (!passwordData.password || passwordData.password.trim() === "") {
      objErrors.password = "Password is required";
    } else if (passwordData.password.length < 8) {
      objErrors.password = "Password must be at least 8 characters";
    } else if (!/(?=.*[a-z])/.test(passwordData.password)) {
      objErrors.password = "Password must contain at least one lowercase letter";
    } else if (!/(?=.*[A-Z])/.test(passwordData.password)) {
      objErrors.password = "Password must contain at least one uppercase letter";
    } else if (!/(?=.*\d)/.test(passwordData.password)) {
      objErrors.password = "Password must contain at least one number";
    }

    if (!passwordData.confirmPassword || passwordData.confirmPassword.trim() === "") {
      objErrors.confirmPassword = "Confirm Password is required";
    } else if (passwordData.password !== passwordData.confirmPassword) {
      objErrors.confirmPassword = "Passwords do not match";
    }

    return objErrors;
  };

  const handleSubmit = async () => {
    const validationErrors = validatePassword();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    if (!token) {
      message.error("Token is missing. Please use a valid link.");
      return;
    }

    try {
      setIsLoading(true);
      const payload = {
        token: token,
        newPassword: passwordData.password,
      };

      const response = await postApi(SET_STUDENT_PASSWORD, payload);

      if (response.status === 200) {
        successToast(response.message || "Password set successfully");
        console.log("responseMessage", response.message);
        setPasswordData({ password: "", confirmPassword: "" });
        setErrors({});
        setSuccessModal(true);
        setSuccessResponse(response.message);
      }
    } catch (error) {
      errorToast(
      error?.response?.data?.message || error?.message
    );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="student-set-password">
      <div className="password-container">
        <div className="logo-section">
          {/* Add your logo here */}
          <img src={LOGO} alt="Logo" className="logo" />
          <h1>Set Your Password</h1>
          <p>Please create a secure password for your account</p>
        </div>

        <div className="form-section">
          <FormInputs
            title="Password"
            type="password"
            placeholder="Enter password"
            value={passwordData.password}
            onChange={(e) => {
              setPasswordData({ ...passwordData, password: e.target.value });
              setErrors({ ...errors, password: "" });
            }}
            errorMessage={errors.password}
            disabled={isLoading}
          />

          <FormInputs
            title="Confirm Password"
            type="password"
            placeholder="Re-enter password"
            value={passwordData.confirmPassword}
            onChange={(e) => {
              setPasswordData({
                ...passwordData,
                confirmPassword: e.target.value,
              });
              setErrors({ ...errors, confirmPassword: "" });
            }}
            errorMessage={errors.confirmPassword}
            disabled={isLoading}
          />

          <div className="password-requirements">
            <p>Password must contain:</p>
            <ul>
              <li>At least 8 characters</li>
              <li>One uppercase letter</li>
              <li>One lowercase letter</li>
              <li>One number</li>
            </ul>
          </div>

          <Buttons
            variant="primary"
            onClick={handleSubmit}
            disabled={isLoading}
            style={{ width: "100%", marginTop: "20px" }}
          >
            {isLoading ? "Setting Password..." : "Set Password"}
          </Buttons>
        </div>
        {successModal && (
  <div className="success-modal-overlay">
    <div className="success-modal">
      <h2>{successResponse}</h2>
      <Buttons
        variant="primary"
        onClick={() => navigate("/login")}
        style={{ marginTop: "20px" }}
      >
        Go to Login
      </Buttons>
    </div>
  </div>
)}
      </div>
    </div>
  );
};

export default StudentSetPassword;